import React, { Component } from "react";
import PropTypes from "prop-types";

import Ball from "./Ball";
// import "./GameTube.scss";

class GameTube extends Component {
  static propTypes = {
    viewedNumbers: PropTypes.array,
  };

  static defaultProps = {
    viewedNumbers: [],
  };

  render() {
    const { viewedNumbers } = this.props;

    const balls = viewedNumbers.map((number) => (
      <Ball number={number} key={number} animate={true} />
    ));

    return (
      <div className="game-tube">
        <div className="tube">
          <div className="balls-container">{balls}</div>
          <div className="tube2">
            <div className="border-neck" />
            <div className="neck" />
          </div>
        </div>
      </div>
    );
  }
}
export default GameTube;
